const ExportNotFound = () => (
  <div className="text-center pad-top30">No Export Found.</div>
);

export default ExportNotFound;
